import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Observable, of, OperatorFunction, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { GetProviderNameResponse, Invoice, InvoicePaginationData, LimosDataResponse } from 'src/app/models/limos/limos.models';
import { LimosService } from 'src/app/services/limos.service';
import { AppUtils } from 'src/app/utilities/app.utils';
import { environment } from 'src/environments/environment';
import { SortDirection } from '../../providers/providers.component';

@Component({
  selector: 'app-lien-representative',
  templateUrl: './lien-representative.component.html',
  styleUrls: ['./lien-representative.component.scss']
})
export class LienRepresentativeComponent implements OnInit, OnDestroy {
  invoicePage = 1;
  invoiceLimit = 30;
  invoiceTotal: number;
  invoices: Invoice[] = [];
  @Output() invoiceData = new EventEmitter<Invoice[]>();
  @BlockUI('invoice-list')
  invoiceListBlockUI: NgBlockUI;
  private unsubscribe$ = new Subject<void>();
  invoiceListOrderBy = 'id';
  invoiceListOrderDirection: SortDirection = 'asc';
  addClientContactForm:FormGroup;
  searchCompanyLoader: boolean;
  @Input() tabType: string;

  constructor(
    private limosService: LimosService,
    private appUtils: AppUtils,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private modalService:NgbModal,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.getInvoices();
    this.initClientContactForm();
  }

  initClientContactForm(){
    this.addClientContactForm = this.fb.group({
      client: new FormControl(''),
      username: new FormControl(''),
      password: new FormControl(''),
      first_name: new FormControl(''),
      last_name: new FormControl(''),
      dob: new FormControl(''),
      title: new FormControl(''),
      email: new FormControl(''),
      work_phone: new FormControl(''),
      mobile_phone: new FormControl(''),
      general_notes: new FormControl(''),
    });
  }

  getInvoices() {
    this.invoiceListBlockUI.start();

    const filterBy = this.activatedRoute.snapshot.params['limos_id'] || '';

    const $invoiceList = this.limosService.getInvoiceList(
      this.invoiceLimit,
      this.invoicePage,
      this.invoiceListOrderBy,
      this.invoiceListOrderDirection,
      filterBy
    );

    $invoiceList.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (resp: LimosDataResponse<InvoicePaginationData>) => {
        const { hits, estimatedTotalHits } = resp.details;
        this.invoices = hits.map((invoice) => {
          return {
            ...invoice,
            total:
              typeof invoice.total === 'string'
                ? parseFloat(invoice.total.replace(/[^0-9.-]+/g, ''))
                : invoice.total,
          };
        });

        this.invoiceTotal = estimatedTotalHits;
        this.invoiceData.emit(this.invoices);

        this.invoiceListBlockUI.stop();
      },
      (error) => {
        console.error('Error fetching invoices:', error);
        this.invoiceListBlockUI.stop();
      }
    );
  }

  onPageChangeinvoices(event: any) {
    this.invoicePage = event;
    this.getInvoices();
  }

  onSizeChangeinvoices(limit: number) {
    this.invoiceLimit = limit;
    this.invoicePage = 1;
    this.getInvoices();
  }

  sortColumn(column: string) {
    this.invoiceListOrderBy = column;
    this.invoiceListOrderDirection =
      this.invoiceListOrderDirection === 'asc' ? 'desc' : 'asc';
    this.getInvoices();
  }

  openPopup(content, size = 'md',service=this.modalService) {
    service.open(content, {
      ariaDescribedBy: 'modal-basic-title',
      windowClass: 'groupModal',
      size,
      centered: true,
    });
  }

  searchCompanyFormatter = (x: any) => x.provider_name_business;

  searchCompany: OperatorFunction<string, readonly any[]> = (
    text$: Observable<string>
  ) =>
    text$.pipe(
      tap((term) => {
        if (term.length <= 2) {
          this.searchCompanyLoader = false;
        }
      }),
      debounceTime(1000),
      distinctUntilChanged(),
      tap((term) => {
        if (term.length > 2) {
          this.searchCompanyLoader = true;
        }
      }),
      switchMap((term) =>
        term.length < 3
          ? []
          : this.http
              .get<GetProviderNameResponse>(
                `${environment.fireStoreApiUrl}/api/v2/liens/provider-names/?q=${term}&limit=20&offset=1`
              )
              .pipe(
                tap((result) => {
                  if (result) {
                    this.searchCompanyLoader = false;
                  }
                }),
                map((results:any) => {
                  const data = results.details.hits;
                  const filteredResult =
                    data.filter((result) =>
                      result.provider_name_business
                        .toLowerCase()
                        .startsWith(term.toLowerCase())
                    );
                  return [...filteredResult];
                }),
                catchError(() => {
                  this.searchCompanyLoader = false;
                  return of([]);
                })
              )
      )
    );

  selectedCompany(){

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
